(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProfessionDeleteController',ProfessionDeleteController);

    ProfessionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Profession'];

    function ProfessionDeleteController($uibModalInstance, entity, Profession) {
        var vm = this;
        vm.profession = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Profession.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
